import { render, staticRenderFns } from "./AiMappingList.vue?vue&type=template&id=611bb16d"
import script from "./AiMappingList.vue?vue&type=script&lang=js"
export * from "./AiMappingList.vue?vue&type=script&lang=js"
import style0 from "./AiMappingList.vue?vue&type=style&index=0&id=611bb16d&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports